export const TOAST_TEXT = {
  ADD_BOOKMARK: "お気に入りに登録しました",
  DELETE_BOOKMARK: "お気に入りから削除しました",
  FAILED_ADD_BOOKMARK: "お気に入り登録に失敗しました",
  FAILED_DELETE_BOOKMARK: "お気に入り削除に失敗しました",
  FAILED_DELETE_CONTINUE_WATCHING: "続きから見る削除に失敗しました",
  ADD_PROFILE: "プロフィールが追加されました",
  UPDATE_PROFILE: "プロフィールが更新されました",
  DELETE_PROFILE: "プロフィールが削除されました",
  START_DOWNLOAD: "ダウンロードを開始します",
  FAILED_DOWNLOAD: "ダウンロードに失敗しました",
  COPY_URL: "URLをコピーしました",
  FAILED_COPY_URL: "URLのコピーに失敗しました",
  ADD_REVIEW: "投稿ありがとうございました！",
  END_OF_SPOT_LIVE: "この配信は終了しました",
  SUCCESS_PURCHASE: "購入は完了しました",
  SUCCESS_COPY: "コピーしました",
  FAILED_COPY: "コピーに失敗しました",
  ADD_BLOCK_USER: "ユーザーをブロックしました",
  SUCCESS_REPORT_USER: "ユーザーを通報しました",
  FAILED_POST_COMMENT: "コメントの投稿に失敗しました",
  FAILED_GET_USER_INFO: "ユーザー情報の取得に失敗しました",
  NON_AFFILIATE_PRODUCT: "アフィリエイト対象外作品です",
  AFFILIATE_UNDER_REVIEW: "アフィリエイトに登録されたサイトの審査中です。今しばらくお待ちください",
  NON_AFFILIATE_USER: "アフィリエイト未登録ユーザーです",
  // TODO: (okita) 汎用エラー文言決定次第修正する
  COMMON_ERROR: "☆汎用toastエラー",
} as const;

export const TOAST_BUTTON_TEXT = {
  TO_YOUR_REVIEW: "あなたのレビュー情報へ",
} as const;

export type ToastTextType = keyof typeof TOAST_TEXT;
export type ToastButtonTextType = keyof typeof TOAST_BUTTON_TEXT;
